export default "__VITE_ASSET__BjNHDTv2__"